import { PieChartOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import DataTable from "../../../../Components/DataTable/DataTable";
import { toJalaali } from "jalaali-js";
import api from "../../../../api/api";
import { message } from "antd";
import { useNavigate } from "react-router-dom";

const OperatorsReport = () => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({});
  const navigate = useNavigate();

  useEffect(() => loadData(1, 100), []);

  const columns = [
    {
      title: "نقشه راه",
      dataIndex: "roadmapId",
      render: (value, record) => {
        return (
          <div
            onClick={() => navigate(`/user-roadmap/${value}`)}
            style={{
              display: "flex",
              justifyContent: "center",
              width: "2rem",
              cursor: "pointer",
            }}
          >
            <span>{value}</span>
          </div>
        );
      },
    },
    {
      title: "اپراتور",
      dataIndex: "operatorName",
      searchable: true,
    },
    {
      title: "نام کاربر",
      dataIndex: "userName",
      searchable: true,
    },
    {
      title: "نام خانوادگی کاربر",
      dataIndex: "userFname",
      searchable: true,
    },
    {
      title: "شروع",
      dataIndex: "createdAt",
      render: (value, record) => {
        try {
          const jsDate = new Date(value);
          const jalali = toJalaali(jsDate);
          return (
            <span>
              {jsDate.getHours()}:{jsDate.getMinutes()}:{jsDate.getSeconds()} -{" "}
              {jalali.jy}/{jalali.jm}/{jalali.jd}
            </span>
          );
        } catch (error) {}
      },
    },
    {
      title: "استفاده از جنریتور",
      dataIndex: "generator_used_at",
      render: (value, record) => {
        if (!value) return <span>-</span>;
        try {
          const jsDate = new Date(value);
          const jalali = toJalaali(jsDate);
          return (
            <span>
              {jsDate.getHours()}:{jsDate.getMinutes()}:{jsDate.getSeconds()} -{" "}
              {jalali.jy}/{jalali.jm}/{jalali.jd}
            </span>
          );
        } catch (error) {
          return <span>-</span>;
        }
      },
    },
    {
      title: "پایان",
      dataIndex: "updatedAt",
      render: (value, record) => {
        try {
          const jsDate = new Date(value);
          const jalali = toJalaali(jsDate);
          return (
            <span>
              {jsDate.getHours()}:{jsDate.getMinutes()}:{jsDate.getSeconds()} -{" "}
              {jalali.jy}/{jalali.jm}/{jalali.jd}
            </span>
          );
        } catch (error) {}
      },
    },
    {
      title: "مجموع",
      dataIndex: "total",
      render: (_, record) => {
        const createdAt = new Date(record.createdAt);
        const updatedAt = new Date(record.updatedAt);

        const diffInSec = (updatedAt - createdAt) / 1000;

        const hour = Math.floor(diffInSec / 3600);
        const min = Math.floor((diffInSec - hour * 3600) / 60);
        const sec = Math.floor(diffInSec - min * 60);

        return `${hour}:${min}:${sec}`;
      },
    },
    {
      title: "IP",
      dataIndex: "ip",
    },
  ];

  const loadData = (page = 1, pageSize = 100, filters = {}) => {
    api
      .post("/operators-monitoring/history", {
        page,
        pageSize,
        filters,
      })
      .then((res) => {
        setPagination(res.data.pagination);
        setData(
          res.data.results.map((e) => ({
            operatorName: e?.operator?.lastname,
            createdAt: e.createdAt,
            updatedAt: e.updatedAt,
            userName: e?.roadmap?.users_permissions_user?.firstname,
            userFname: e?.roadmap?.users_permissions_user?.lastname,
            roadmapId: e?.roadmap?.epoll_response?.id,
            ip: e.ip,
            generator_used_at: e.generator_used_at,
          }))
        );
      })
      .catch((err) => message.error("خطا در دریافت لیست گزارشات مانیتور"));
  };

  const filtersBeautify = (fData) => {
    return {
      ...(fData.operatorName?.at(0)
        ? { operatorFname: fData.operatorName?.at(0) }
        : {}),
      ...(fData.userFname?.at(0) ? { fname: fData.userFname?.at(0) } : {}),
      ...(fData.userName?.at(0) ? { name: fData.userName?.at(0) } : {}),
    };
  };

  return (
    <>
      <DataTable
        tableKey="operators-report"
        recordsCount={pagination?.total}
        dynamicPagination
        id="OperatorsReport"
        filtersBeautify={filtersBeautify}
        dataSource={data}
        setDataSource={setData}
        columns={columns}
        permissionsPrefix="flags"
        reload={loadData}
        recordCreatorDisabled
        header={{
          title: (
            <div style={{ display: "flex", alignItems: "center", gap: "1rem" }}>
              <span>گزارش اپراتور ها</span>
            </div>
          ),
          avatar: { icon: <PieChartOutlined />, size: "large" },
        }}
      />
    </>
  );
};

export default OperatorsReport;
